import { Table, Tag, Tooltip, message, Spin } from "antd";
import intl from "react-intl-universal";
import { dealFileSize } from "@/utils/dealFileSize";
import styles from "./FileList.module.scss";
import downImg from "@/assets/images/discover/down.png";
import previewImg from "@/assets/images/discover/view.png";
import { useEffect, useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import { getParentInfo } from "@/utils/buildDirectoryTree";
import { downloadPoint, downloadResourceFiles, getResourceFileDownloadUrl } from "@/apis/discover";
import { collectResourceFileUuids } from "@/utils/resourceDownload";
const FileList = ({ resourceUuid, directoryTree,previewFileData,curData }) => {
  const [dataSource, setDataSource] = useState([]);
  useEffect(() => {
    setDataSource(cloneDeep(directoryTree));
  }, [directoryTree]);
  const [loading, setLoading] = useState(false);
  const [expandKey,setExpendKey] = useState([])

  const columns = [
    {
      title: intl.get("Share.File Name"),
      key: "name",
      dataIndex: "name",
      width: 500,
      render: (_,record) => (
        <span>
          {record.name}
        </span>
      ),
    },
    {
      title: intl.get("Share.Format"),
      key: "suffix",
      dataIndex: "suffix",
      width: 100,
      render: (_,record) => (
        <Tag color="gold">
          {record.type === 'file'? record.suffix:'Folder'}
        </Tag>
      ),
    },
    {
      title: intl.get("Share.File Size"),
      key: "size",
      dataIndex: "size",
      width: 100,
      render: (_, record) => (
        <span>
          {record.type === 'file'?dealFileSize(record.size):'-'}
        </span>
      ),
    },
    {
      title: intl.get("Operation"),
      key: "operate",
      width: 100,
      render: (_, record) => (
        <div className={styles.downBox}>
          <Tooltip title={intl.get("Share.Download the file")}>
            <img
              src={downImg}
              onClick={(e) =>{
                e.stopPropagation();
                downLoadFile(
                 record.type === 'file'? record.key:'-',record.children
                )
              }
              }
            />
          </Tooltip>
          <Tooltip title={intl.get("Discover.View")}>
            {record.type === "file" ? (
              <img
                src={previewImg}
                onClick={(e) => {
                  e.stopPropagation();
                  previewFile(record)
                }}
              />
            ) : (
              ""
            )}
          </Tooltip>
        </div>
      ),
    },
  ];
  //预览文件
  const previewFile = (data) => {
    previewFileData(data)
  };
// 压缩文件
const compressFile = async (fileUuids) => {
    setLoading(true);
    try {
      await downloadResourceFiles(resourceUuid, fileUuids);
      setPoint(500);
    } catch (error) {
      setLoading(false);
    }
  };
  // 下载埋点
const setPoint = (time) => {
  setTimeout(() => {
    setLoading(false);
    message.success({
      content: intl.get("File downloading, please wait patiently"),
      duration: 4,
    });
  }, time);
  downloadPoint({
    resourceUuid: resourceUuid,
  })
    .then((res) => {
      // console.log(res)
    })
    .catch((err) => {
      console.log(err);
    });
};
const downLoadFile = async (id, children) => {
    if (id === '-') {
      const ids = collectResourceFileUuids(children || []);
      if (ids.length) await compressFile(ids);
      else message.warning("该目录下暂无文件！");
    } else {
      setLoading(true);
      try {
        const url = await getResourceFileDownloadUrl(resourceUuid, id);
        window.location.assign(url);
        setPoint(2000);
      } catch (error) {
        setLoading(false);
      }
    }
  };
  useEffect(()=>{
    if (curData) {
      const parentNodes = getParentInfo(directoryTree, curData.key);
      if (parentNodes.length) {
          setExpendKey([parentNodes[0].key])
      }
    }
  },[curData])
  return (
    <Spin
      spinning={loading}
      tip={intl.get("File downloading, please wait patiently")}
    >
        {dataSource.length?<Table
        rowKey={(record) =>
          record.key
        }
        expandedRowKeys={expandKey}
        expandRowByClick
        defaultExpandAllRows
        onExpand={(expanded,record)=>{
            const keys = expanded 
            ? [...expandKey, record.key] 
            : expandKey.filter(key => key !== record.key);
            setExpendKey(keys);
        }}
        size="small"
        scroll={{ y: "350px" }}
        pagination={false}
        dataSource={dataSource}
        columns={columns}
      />:""}
      
    </Spin>
  );
};

export default FileList;
